import { Button, ButtonProps } from "@mui/material";
import { Flex } from "~/components/Flex";
import { Add as AddIcon } from "@mui/icons-material";
import { IndentIcon } from "~/icons";

type AddConditionRowProps = {
  onClick: ButtonProps["onClick"];
  disabled: boolean;
};

export const AddConditionBuilderRow = ({
  onClick,
  disabled,
}: AddConditionRowProps) => {
  return (
    <Flex gap={1} alignItems="center" ml={6}>
      <IndentIcon sx={{ color: (theme) => theme.palette.text.disabled }} />
      <Button
        variant="text"
        disabled={disabled}
        sx={{
          color: (theme) => theme.palette.secondary.light,
        }}
        onClick={onClick}
        startIcon={<AddIcon />}
        data-testid="add-condition-button"
      >
        Add Condition
      </Button>
    </Flex>
  );
};
